import { useMemo } from "react";
import { getMessageSettingRCS } from "../../../utils/helpers";

export function useCountChars(message) {
  const { count, maxCharacters, messages, type } = useMemo(() => {
    const settings = getMessageSettingRCS(message);
    const Resolver = new TextEncoder();

    const length = message ? Resolver.encode(message).length : 0;

    return {
      count: length,
      maxCharacters: settings.limit,
      messages: length ? Math.ceil(length / settings.limit) : 0,
      type: settings.type,
    };
  }, [message]);

  return { count, maxCharacters, messages, type };
}
